import { configureStore } from "@reduxjs/toolkit";
import userSlice from "../Reducers/Usuario";
import gastosSlice from "../Reducers/Gastos";

export const store = configureStore({
  reducer: { user: userSlice, gastos: gastosSlice },
});
